module.exports = __webpack_public_path__ + "img/unvip.f8300127.png";